import React, { Suspense, lazy } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Button, Empty, Spin } from 'antd';
import { ArrowLeftOutlined, EnvironmentOutlined } from '@ant-design/icons';

const MapPage = lazy(() => import('../../components/map'));

const BatchTracking: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const batchId = location.state?.batchId;
  const batchName = location.state?.batchName;

  const goBack = () => navigate('/batches/view', { state: { batchId } });

  if (!batchId) {
    return (
      <div className="batch-view-page">
        <div className="batch-view-header">
          <Button type="text" icon={<ArrowLeftOutlined />} onClick={() => navigate('/batches')} className="batch-back-btn">Batches</Button>
        </div>
        <Empty description="No batch context found" style={{ marginTop: 40 }} />
      </div>
    );
  }

  return (
    <div className="batch-view-page">
      <div className="batch-view-header">
        <Button type="text" icon={<ArrowLeftOutlined />} onClick={goBack} className="batch-back-btn">{batchName || 'Batch'}</Button>
      </div>

      <div className="sd-title-row" style={{ marginBottom: 16 }}>
        <h2 className="sd-title"><EnvironmentOutlined style={{ marginRight: 10 }} />Live Tracking</h2>
      </div>

      <div className="batch-tracking-pane">
        <Suspense fallback={<div style={{ textAlign: 'center', padding: '48px' }}><Spin size="large" tip="Loading map..." /></div>}>
          <MapPage batchId={batchId} active={true}  />
        </Suspense>
      </div>
    </div>
  );
};

export default BatchTracking;
